import React from "react";

/**
 * PixelLoader
 * Animated pixel spinner or loading bar.
 *
 * Props:
 *   variant  — "spinner" | "bar" | "dots"  (default: "spinner")
 *   size     — "sm" | "md" | "lg"          (default: "md")
 *   text     — string — optional loading text
 *   fullPage — boolean — centers loader in full viewport
 *   color    — CSS color (default: var(--color-accent))
 */
const PixelLoader = ({
  variant = "spinner",
  size = "md",
  text,
  fullPage = false,
  color,
}) => {
  const style = color ? { "--loader-color": color } : {};

  const content = (
    <div
      className={`pixel-loader pixel-loader--${variant} pixel-loader--${size}`}
      style={style}
      role="status"
      aria-label={text || "در حال بارگذاری..."}
    >
      {variant === "spinner" && (
        <div className="pixel-loader__spinner">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="pixel-loader__dot"
              style={{ "--i": i }}
            />
          ))}
        </div>
      )}

      {variant === "bar" && (
        <div className="pixel-loader__bar-track">
          <div className="pixel-loader__bar-fill" />
        </div>
      )}

      {variant === "dots" && (
        <div className="pixel-loader__dots">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="pixel-loader__blink-dot"
              style={{ "--i": i }}
            />
          ))}
        </div>
      )}

      {text && <p className="pixel-loader__text">{text}</p>}
    </div>
  );

  if (fullPage) {
    return <div className="pixel-loader-fullpage">{content}</div>;
  }

  return content;
};

export default PixelLoader;

/*
─── CSS to add in pixel.css / animations.css ──────────────────────────

*/